(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDeleteController',PaynetModeDeleteController);

    PaynetModeDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaynetMode'];

    function PaynetModeDeleteController($uibModalInstance, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PaynetMode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
